var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 53,
    viewBox: "0 0 59 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 4.60416C59 6.64458 57.3529 8.29166 55.3125 8.29166H3.6875C1.64708 8.29166 0 6.64458 0 4.60416C0 2.56375 1.64708 0.916664 3.6875 0.916664H55.3125C57.3529 0.916664 59 2.56375 59 4.60416ZM35.6458 45.1667H23.3542C21.3137 45.1667 19.6667 46.8137 19.6667 48.8542C19.6667 50.8946 21.3137 52.5417 23.3542 52.5417H35.6458C37.6862 52.5417 39.3333 50.8946 39.3333 48.8542C39.3333 46.8137 37.6862 45.1667 35.6458 45.1667ZM45.4792 23.0417H13.5208C11.4804 23.0417 9.83333 24.6887 9.83333 26.7292C9.83333 28.7696 11.4804 30.4167 13.5208 30.4167H45.4792C47.5196 30.4167 49.1667 28.7696 49.1667 26.7292C49.1667 24.6887 47.5196 23.0417 45.4792 23.0417Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlack);
export default __webpack_public_path__ + "static/media/filter-black.cad0e3da6792945bea3bbfe9c31ddba3.svg";
export { ForwardRef as ReactComponent };